import { useCallback } from "react";
import useDictionary from "./useDictionary";
import { pureTranslate } from "../Translate";

var useTranslate = function useTranslate() {
  var dictionary = useDictionary();
  return useCallback(function (key, values) {
    return pureTranslate(dictionary, key, values);
  }, [dictionary]);
};

export default useTranslate;